import { Stack } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

export const FormInputContainer: FC<PropsWithChildren> = (props) => {
	return (
		<Stack direction={"column"} rowGap="4px">
			{props.children}
		</Stack>
	);
};
